export default [
  {
      title: 'Tableau de Bord',
      route: 'home-page',
      icon: 'HomeIcon',
      typeUser: 'all',
  }
]
